import type { Dispatch } from 'redux';
import { connect } from '@atlassian/jira-react-redux';
import { FETCH_COMPONENTS_REASON } from '../../common/constants/fetch-components-reason';

import { getComponentsPageRequest } from '../../state/actions';
import { get as getAnalyticsData } from '../../state/analytics/selectors';
import { patchQuery } from '../../state/query/actions';
import { getFilter } from '../../state/query/selectors';
import type { State } from '../../state/reducer';

import FilterView from './view';

const mapStateToProps = (state: State) => ({
	value: getFilter(state),
	analyticsData: getAnalyticsData(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	onChange: (value: string) => {
		dispatch(patchQuery({ filter: value, page: 1 }));
		dispatch(
			getComponentsPageRequest({
				page: 1,
				initiatedBy: FETCH_COMPONENTS_REASON.FILTERING,
			}),
		);
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterView);
